// extracted by mini-css-extract-plugin
module.exports = {"SliderControls":"styles_SliderControls__vfH7Y","button":"styles_button__VTBlF","active":"styles_active__rvrpy"};